import { spaceCadet } from '@cogneed/react-utils';
import { styled } from '@mui/material';
import PageLayout from '../../../../../Layouts/PageLayout';

const StyledBox = styled(PageLayout)(() => ({
  '& .MuiBox-root.header': {
    boxShadow: '0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)',
    padding: '8px 24px',

    '& .MuiButtonBase-root': {
      fontSize: 12,
      lineHeight: '20px',
      fontWeight: 600,
      color: spaceCadet[400],
      textDecoration: 'none',
      display: 'flex',
      gap: 4,
      alignItems: 'center',
      '&:hover': {
        color: spaceCadet[500],
        textDecoration: 'none',
      },
      '& svg': {
        fontSize: 12,
        display: 'block',
      },
    },

    '& .MuiTypography-h1': {
      color: spaceCadet[800],
      fontWeight: 700,
      fontSize: 16,
      lineHeight: '24px',
    },
  },
  '& > .MuiBox-root.content': {
    '& .MuiAlert-standardError': {
      '& .MuiAlert-message': {
        '& .MuiTypography-root': {
          fontSize: '12px',
          fontWeight: 400,
        },
        '& strong': {
          marginLeft: 4,
          '&::before': { content: 'open-quote' },
          '&::after': { content: 'close-quote' },
        },
      },
    },
  },
}));

export default StyledBox;
